import { DinamicsOfObjectsTable } from "./Dynamicsofobjectstable"
import { ConditionOfThePropertyTable } from "./Conditionofthepropertytable"
import style from './style.module.css';
import { OwnershipTable } from "./Ownershiptable";
import { Button, Modal } from "antd";
import { PurposeTable } from "./Purposetable";
import { useGetEstateAnalyticaForYearDataQuery, useGetEstateAnalyticalPurposeOwnershipDataQuery, useGetEstateAnalyticalbyconditionDataQuery, useGetReportRealEstateMutation } from "../../../../redux/api/realEstate/realEstateApi";
import { useState } from "react";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { PreloaderSvg } from "../../../preloaderSvg/PreloaderSvg"; 
import { MapWithPoligons } from "../../../MapWithPoligons";
import L from 'leaflet';
import { GeneralData } from "../../../generaldata";

export interface ImmovableBlockProps {
    alias: string;
    year?: number;
}

export const ImmovableBlock: React.FC<ImmovableBlockProps> = ({ alias, year }) => {
    const {t} = useTranslation()
    const [getRealEstateReport] = useGetReportRealEstateMutation();
    const currentYear = year || new Date().getFullYear();
    
    const { data, error, isLoading } = useGetEstateAnalyticaForYearDataQuery({
        governmentAlias: alias,
        year: currentYear
    });

    const { data: purposeOwnershipData, isFetching } = useGetEstateAnalyticalPurposeOwnershipDataQuery({
        governmentAlias: alias,
        year: currentYear
    });

    const { data: conditionData, isLoading: isLoadingAnalytical } = useGetEstateAnalyticalbyconditionDataQuery({
        governmentAlias: alias,
        year: currentYear
    });

    const organizationName = conditionData?.res?.[0]?.organizationName;

    const customMarkerIcon = L.icon({
        iconUrl: '/imort.svg', 
        iconSize: [35, 55],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });

    const handleDownload = async () => {
        try {
            const payload = {
                governmentAlias: alias,
                startDate: `${currentYear}-01-01`,
                endDate: `${currentYear}-12-31`,
                language: i18n.language,
            };
            
            const blob = await getRealEstateReport(payload).unwrap();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `RealEstate_Report_${currentYear}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            Modal.error({
                title: t("msg.error"),
                content: t("reports.download_failed"),
            });
        }
    };

    if (error) {
        return <div>Ошибка при загрузке данных</div>;
    }

    if (isLoading || isLoadingAnalytical || isFetching) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <PreloaderSvg />
            </div>
        );
    }
    
    return (
        <div className={style.container_main}>
            {/* <GeneralData/> */}
            <div className={style.title}>
                <h1>{t("Immovable_property")} - {organizationName || t('Data not available')}</h1>
                <Button 
                    style={{marginLeft: '5px'}} 
                    type="primary" 
                    icon={<img src="../../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />}
                    onClick={handleDownload}
                >
                    {t('general.generate_report')}
                </Button>
            </div>
         
            <div className={style.container}>
                <div className={style.content}>
                    <MapWithPoligons
                        extraData={data?.res?.map(item => ({
                            ...item,
                            popupContent: `
                                <div style="padding: 8px;">
                                    <h4 style="margin: 0 0 8px 0; color: #333; font-size: 16px;">
                                        ${item.name || 'Без названия'}
                                    </h4>
                                    <p style="margin: 4px 0; color: #666;">
                                        <strong style="color: #333;">${t('Area')}:</strong> ${item.square || '-'}
                                    </p>
                                    <p style="margin: 4px 0; color: #666;">
                                        <strong style="color: #333;">${t('Purpose')}:</strong> ${item.purpose || '-'}
                                    </p>
                                    <p style="margin: 4px 0; color: #666;">
                                        <strong style="color: #333;">${t('Form of ownership')}:</strong> ${item.ownershipForm || '-'}
                                    </p>
                                    <p style="margin: 4px 0; color: #666;">
                                        <strong style="color: #333;">${t('Condition')}:</strong> ${item.condition || '-'}
                                    </p>
                                </div>
                            `
                        }))}
                        latitude={41.5089324}
                        longitude={74.724091}
                        customIcon={customMarkerIcon}
                        type={["REGION"]}
                    />

                    <div className={style.topRow}>
                        <DinamicsOfObjectsTable data={purposeOwnershipData?.res} />
                        <ConditionOfThePropertyTable data={conditionData?.res} />
                    </div>
                    <div className={style.tables}>
                        <PurposeTable data={purposeOwnershipData?.res} />
                        <OwnershipTable data={purposeOwnershipData?.res} />
                    </div>
                </div>
            </div>
        </div>
    );
};
